import { render } from "./ClearInventory.vue?vue&type=template&id=298f0f82"
import script from "./ClearInventory.vue?vue&type=script&lang=js"
export * from "./ClearInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ClearInventory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "298f0f82"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('298f0f82', __exports__)) {
    api.reload('298f0f82', __exports__)
  }
  
  module.hot.accept("./ClearInventory.vue?vue&type=template&id=298f0f82", () => {
    api.rerender('298f0f82', render)
  })

}


export default __exports__